import { render, staticRenderFns } from "./RecommenderRule.vue?vue&type=template&id=0818cd80&"
import script from "./RecommenderRule.vue?vue&type=script&lang=js&"
export * from "./RecommenderRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports